module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "67",
      "height": "67",
      "viewBox": "0 0 67 67",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "33.5",
      "cy": "33.5",
      "r": "33.5",
      "fill": "#F6F5F5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.5957 11.9794L23.4735 10.1016H44.1293L46.946 12.9183V55.1688L44.1293 57.0466H24.4124L21.5957 55.1688V11.9794Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.6309 31.9785L28.0039 34.6055L28.9327 35.5342L31.5597 32.9072L30.6309 31.9785Z",
      "fill": "#060606",
      "stroke": "white",
      "stroke-width": "0.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.5142 28.6913L30.6333 36.5723L31.5621 37.501L39.443 29.6201L38.5142 28.6913Z",
      "fill": "#060606",
      "stroke": "white",
      "stroke-width": "0.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.8923 26.7214L31.9521 30.6616L32.8809 31.5904L36.8211 27.6502L35.8923 26.7214Z",
      "fill": "#060606",
      "stroke": "white",
      "stroke-width": "0.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.3409 52.3672H24.6161C24.4072 52.3672 24.2069 52.4502 24.0593 52.5978C23.9116 52.7455 23.8286 52.9458 23.8286 53.1547C23.8286 53.3635 23.9116 53.5638 24.0593 53.7115C24.2069 53.8592 24.4072 53.9421 24.6161 53.9421H29.3409C29.5497 53.9421 29.75 53.8592 29.8977 53.7115C30.0454 53.5638 30.1283 53.3635 30.1283 53.1547C30.1283 52.9458 30.0454 52.7455 29.8977 52.5978C29.75 52.4502 29.5497 52.3672 29.3409 52.3672Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.4944 52.3672H31.7069C31.4981 52.3672 31.2978 52.4502 31.1501 52.5978C31.0024 52.7455 30.9194 52.9458 30.9194 53.1547C30.9194 53.3635 31.0024 53.5638 31.1501 53.7115C31.2978 53.8592 31.4981 53.9421 31.7069 53.9421H32.4944C32.7032 53.9421 32.9035 53.8592 33.0512 53.7115C33.1989 53.5638 33.2818 53.3635 33.2818 53.1547C33.2818 52.9458 33.1989 52.7455 33.0512 52.5978C32.9035 52.4502 32.7032 52.3672 32.4944 52.3672Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M43.5162 8.27051H24.617C23.5731 8.27168 22.5723 8.68688 21.8342 9.42502C21.0961 10.1632 20.6809 11.164 20.6797 12.2078V53.1561C20.6809 54.1999 21.0961 55.2007 21.8342 55.9389C22.5723 56.677 23.5731 57.0922 24.617 57.0934H43.5162C44.5601 57.0922 45.5609 56.677 46.299 55.9389C47.0371 55.2007 47.4523 54.1999 47.4535 53.1561V12.2078C47.4523 11.164 47.0371 10.1632 46.299 9.42502C45.5609 8.68688 44.5601 8.27168 43.5162 8.27051ZM39.4058 9.84544L38.9333 12.2078H29.2L28.7275 9.84544H39.4058ZM45.8786 53.1561C45.8779 53.7824 45.6288 54.3829 45.1859 54.8257C44.743 55.2686 44.1425 55.5177 43.5162 55.5184H24.617C23.9907 55.5177 23.3902 55.2686 22.9473 54.8257C22.5044 54.3829 22.2553 53.7824 22.2546 53.1561V12.2078C22.2553 11.5815 22.5044 10.981 22.9473 10.5381C23.3902 10.0953 23.9907 9.84614 24.617 9.84544H27.1213L27.7821 13.1497C27.8178 13.3283 27.9143 13.4889 28.0551 13.6043C28.1959 13.7197 28.3723 13.7828 28.5543 13.7828H39.5789C39.7609 13.7828 39.9373 13.7197 40.0781 13.6043C40.2189 13.4889 40.3154 13.3283 40.3511 13.1497L41.0119 9.84544H43.5162C44.1425 9.84614 44.743 10.0953 45.1859 10.5381C45.6288 10.981 45.8779 11.5815 45.8786 12.2078V53.1561Z",
      "fill": "#060606",
      "stroke": "#E8E7E5",
      "stroke-width": "0.5"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e16972a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/DeviceIcon.vue
// module id = 730
// module chunks = 0